import {
  BrowserIcon,
  DataTableIcon,
  DurationOutlineIcon,
} from '@carboncopyco/icons';
import { useFlags } from 'launchdarkly-react-client-sdk';

import {
  useGetCloneMetricsQuery,
  useGetRecordingQuery,
} from '@carboncopyco/data';
import { InfoPageSidebar } from '../InfoPageSidebar';
import { useClonePageProps } from './ClonePageContext';
import { hasMetricsData } from './OverviewTab/CloneOverviewCard';
import type { ClonePageTab } from './types';

export const ClonePageSidebar = () => {
  const flags = useFlags();
  const { rootPath, goBack, cloneId, organizationId, workspaceId } =
    useClonePageProps();
  const { data: clone, isLoading: isLoadingClone } = useGetRecordingQuery({
    organizationId,
    id: cloneId,
  });

  const { data: metrics } = useGetCloneMetricsQuery({
    organizationId: organizationId,
    recordingId: cloneId as string,
    workspacesIds: [workspaceId],
  });

  const tabButtons = {
    overview: {
      label: 'Overview',
      icon: <BrowserIcon size={18} />,
    },
    data: {
      label: 'Clone Data',
      icon: <DataTableIcon size={18} />,
      disabled: !flags.cloneExperienceWidget || !hasMetricsData(metrics),
    },
    history: {
      label: 'History',
      icon: <DurationOutlineIcon size={18} />,
    },
  };

  return (
    <InfoPageSidebar<ClonePageTab>
      rootPath={rootPath}
      tabButtons={tabButtons}
      screenshot={clone?.image}
      goBack={goBack}
      isLoading={isLoadingClone}
    />
  );
};
